// API helpers for Bed Retention (G1). Tenant headers are sent explicitly on
// every call — see ipdEnhancementsApi.js for why (per-tab sessionStorage).

import axios from "axios";

const BASE =
  process.env.REACT_APP_BACKEND_ROUTE_URL ||
  "https://manage-dev.hlthtek.com/app/api/";

function authHeaders(extra = {}) {
  const token = sessionStorage.getItem("accessToken") || "";
  return {
    Authorization: `Bearer ${token}`,
    "APP-MODE": sessionStorage.getItem("APP_MODE") || "",
    "ORG-CODE": sessionStorage.getItem("ORG_CODE") || "",
    "USER-ACCESS-KEY": sessionStorage.getItem("USER_ACCESS_KEY") || "",
    USERNAME: sessionStorage.getItem("userName") || "",
    ...extra,
  };
}

export async function retainBed({ bedCode, admissionId, expiresAt, reason }) {
  const body = { bed_code: bedCode, expires_at: expiresAt };
  if (admissionId) body.admission_id = admissionId;
  if (reason) body.reason = reason;
  const res = await axios.post(`${BASE}bed_retention/`, body, {
    headers: authHeaders({ "Content-Type": "application/json" }),
  });
  return res?.data;
}

export async function releaseBedRetention(bedCode, { reason } = {}) {
  const body = {};
  if (reason) body.reason = reason;
  const res = await axios.put(
    `${BASE}bed_retention/${encodeURIComponent(bedCode)}/release/`,
    body,
    { headers: authHeaders({ "Content-Type": "application/json" }) }
  );
  return res?.data;
}

export async function getActiveBedRetentions() {
  const res = await axios.get(`${BASE}bed_retention/?status=active`, {
    headers: authHeaders(),
  });
  return res?.data?.data || [];
}

export async function getBedRetentionHistory(bedCode) {
  const url = bedCode
    ? `${BASE}bed_retention/history/?bed_code=${encodeURIComponent(bedCode)}`
    : `${BASE}bed_retention/history/`;
  const res = await axios.get(url, { headers: authHeaders() });
  return res?.data?.data || [];
}
